import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  html { scroll-behavior: smooth; scroll-padding-top: 100px; }
  body {
    margin: 0;
    background: ${p => p.theme.colors.background.primary[500]};
    color: ${p => p.theme.colors.text.primary[500]};
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    line-height: 1.6;
    transition: background-color 300ms ease, color 300ms ease;
  }
  button, input, textarea { font: inherit; }
  button, a { -webkit-tap-highlight-color: transparent; }
  a { color: inherit; text-underline-offset: 4px; }
  button { color: inherit; }
  :focus-visible {
    outline: 2px solid ${p => p.theme.colors.accent.primary[500]};
    outline-offset: 5px;
  }
  /* Anchor navigation focuses the main landmark; it is not an interactive control. */
  #main-content:focus { outline: none; }
  ::selection {
    background: ${p => p.theme.colors.accent.primary[500]};
    color: ${p => p.theme.accentInk};
  }
  img, svg { max-width: 100%; }
  h1, h2, h3, p { margin: 0; }
  .twitter-tweet { max-width: 100%; }
  @keyframes enter {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after { animation: none !important; transition: none !important; }
  }
`
export default GlobalStyle
